import { useContent } from "@/context/ContentContext";
import { Image as ImageIcon } from "lucide-react";

export default function PageBackdrop({ image, ck }) {
  const c = useContent();
  const img = (ck && c?.content?.[ck]) || image;
  return (
    <>
      <div className="fixed inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${img})` }} aria-hidden="true" />
      <div
        className="fixed inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(10,10,10,0.80) 0%, rgba(10,10,10,0.90) 55%, rgba(5,5,5,0.97) 100%)",
        }}
        aria-hidden="true"
      />
      {ck && c?.editMode && (
        <button data-testid={`backdrop-edit-${ck}`} onClick={() => c.openImage(ck, img)}
          className="fixed top-32 right-4 z-[60] flex items-center gap-1.5 bg-pb-cyan text-black text-[10px] font-black uppercase tracking-widest px-3 py-2 hover:bg-[#BEF264] active:scale-95 transition-all shadow-lg">
          <ImageIcon className="w-3.5 h-3.5" /> Change Backdrop
        </button>
      )}
    </>
  );
}
